import { render, staticRenderFns } from "./SettingWalletedit.vue?vue&type=template&id=6d7e5d76"
import script from "./SettingWalletedit.vue?vue&type=script&lang=js"
export * from "./SettingWalletedit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports